import type { BeforeRequestHook } from "ky";

import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

import type { ApiContext } from "../types";
import { workflowTokenStore } from "../helpers/workflowTokenStore";

// store.dispatch is typed as Dispatch<AnyAction> but auth actions are thunks
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dispatch: (action: any) => any = store.dispatch;

export function makeAuthHook(getToken: () => string | null): BeforeRequestHook {
  return ({ options, request }) => {
    const context = options.context as ApiContext | undefined;
    const token = context?.accessToken ?? getToken();

    if (!token) {
      dispatch(logOut());

      return new Response(JSON.stringify({ error: { message: "Missing authentication token" } }), {
        headers: { "Content-Type": "application/json" },
        status: 401,
      });
    }

    request.headers.set("Authorization", token);
    request.headers.set("Accept", "application/json");
    request.headers.set("x-location-path-name", window.location.pathname);

    return undefined;
  };
}

export const workflowAuthHook: BeforeRequestHook = ({ request }) => {
  const tokens = workflowTokenStore.get();

  if (!tokens?.idToken) {
    dispatch(logOut());

    return new Response(
      JSON.stringify({ error: { message: "Missing workflow authentication token" } }),
      { headers: { "Content-Type": "application/json" }, status: 401 },
    );
  }

  request.headers.set("Authorization", tokens.idToken);
  request.headers.set("Accept", "application/json");
  request.headers.set("x-location-path-name", window.location.pathname);

  return undefined;
};
